import Cookies from 'js-cookie';

import { getStoreCookiePath } from '../selectors';
import { BREAKPOINT_SET } from './constants';
import { getLastKnownResolutionCookieName } from './selectors';

/**
 * Each time resolution changes, we keep track of that change and sync cookie value with it
 * so that next time page is reloaded new value is used
 */
export const setBreakpoint = (value) => (dispatch, getState) => {
  /** first actually apply adaptivity */
  dispatch({ type: BREAKPOINT_SET, value });

  /** after that put the value in cookies for persistence */
  const state = getState();
  const lastKnownResolutionCookieName = getLastKnownResolutionCookieName(state);

  const path = getStoreCookiePath(state);
  Cookies.remove(lastKnownResolutionCookieName);
  Cookies.set(lastKnownResolutionCookieName, value, { expires: 365, path });
};
